import React, { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { resolvePublicUploadUrl } from "../../api/apiConfig/apiConfig";
import AuthService from "../../api/services/AuthService";

const HeaderSearchModal = () => {
  const [searchPair, setSearchPair] = useState("");
  const [allPairs, setAllPairs] = useState([]);
  const [pairsLoading, setPairsLoading] = useState(false);
  const [pairsFetched, setPairsFetched] = useState(false);
  const navigate = useNavigate();

  const fetchPairs = useCallback(async () => {
    if (pairsFetched || pairsLoading) return;
    setPairsLoading(true);
    try {
      const result = await AuthService.getPairs();
      if (result?.success) {
        setAllPairs(result.data || []);
        setPairsFetched(true);
      }
    } catch {
      // ignore
    } finally {
      setPairsLoading(false);
    }
  }, [pairsFetched, pairsLoading]);

  const filteredPairs = useMemo(() => {
    if (!searchPair) return allPairs;
    const q = searchPair.toLowerCase();
    return allPairs.filter((item) => item?.base_currency?.toLowerCase?.()?.includes(q));
  }, [searchPair, allPairs]);

  const nextPage = useCallback(
    (data) => {
      try {
        localStorage.setItem("RecentPair", JSON.stringify(data));
      } catch {
        // ignore
      }
      navigate(`/trade/${data?.base_currency}_${data?.quote_currency}`);
      window.location.reload();
    },
    [navigate]
  );

  return (
    <div
      className="modal fade search_form search_form_modal_2"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
      onFocus={fetchPairs}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="kycTitle">
              Hot Trading Pairs{" "}
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body" onClick={fetchPairs}>
            <form>
              <input
                type="search"
                className="searchfield"
                placeholder="Search here..."
                value={searchPair}
                onChange={(e) => setSearchPair(e.target.value)}
                onFocus={fetchPairs}
              />
            </form>
            <div className="hot_trading_t">
              <div className="table-responsive">
                {pairsLoading ? (
                  <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                    <div className="spinner-border text-primary" role="status" />
                  </div>
                ) : (
                  <table>
                    <tbody>
                      {filteredPairs?.length > 0 ? (
                        filteredPairs.map((item, index) => (
                          <tr key={item?._id || index}>
                            <td onClick={() => nextPage(item)} data-bs-dismiss="modal">
                              <div className="td_first">
                                <div className="icon">
                                  <img src={resolvePublicUploadUrl(item?.icon_path)} alt="icon" />
                                </div>
                                <div className="price_heading">
                                  {" "}
                                  {item?.base_currency} / {item?.quote_currency} <br /> <span>{item?.base_currency_fullname}</span>
                                </div>
                              </div>
                            </td>
                            <td className="right_t price_tb">
                              {item?.buy_price}
                              <span className={`${item?.change_percentage > 0 ? "green" : "red"}`}>{item?.change_percentage}%</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr rowSpan="5" className="no-data-row">
                          <td className="w-100">
                            <div className="no-data-wrapper mt-5">
                              <div className="no_data_s">
                                <img src="/images/no_data_vector.svg" className="img-fluid dark_img" width="96" height="96" alt="" />
                                <img src="/images/no_data_vector_light.png" className="img-fluid light_img" width="96" height="96" alt="" />
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSearchModal;

